<template>
	<div class="main">
        <div class="sec-list">
            <div class="title">
                <span class="main-back" @click="goBack"></span>
                <span>消息中心</span>
            </div>
            <ul id="newsList">
                <li v-for="(value,index) in messageListData" :key="index"><p class="news-title">{{value.content}}</p><p class="news-time">{{value.modifydate | dateFormat}}</p></li>
            </ul>
        </div>
        <Loading v-if="loadingShow"></Loading>
        <NoMore v-if="noData"></NoMore>
    </div>
</template>
<script>
	import {getmessagelist, getuserinfo} from './../axios/api.js'
	import {dateFormat} from './../common/js/util.js'
    import Loading from './../components/loading.vue'
    import NoMore from './../components/loadingNoMore.vue'
    let pgno;
	export default {
		name: 'RegistType',
		data (){
			return {
				messageListData: [],
                loadingShow: false,
                noData: false,
                loadSwitch: true,
                pgno: 1,
			}
		},
        mounted(){
        	//this.getRouteData();
            // 注册scroll事件并监听 
            pgno = this.pgno;
            this.getmessagelist(pgno)
            window.addEventListener('scroll', this.scrollLoadData);
        },
        beforeDestroy (){
            window.removeEventListener('scroll', this.scrollLoadData);
        },
        components: {
            Loading,
            NoMore
        },
		methods:{
			getRouteData (){
				// 获取用户信息
				// if(this.$route.query.user.mediaHeadPic){
				// 	this.userInfo = this.$route.query.user;
				// }
				let that = this;
                getuserinfo().then(result => {
                	if(result.stat != 1){
                		that.$router.push({path: '/Login'})
                		return;
                	}
                    if (result.user) {
						that.userInfo = result.user;
						if(result.user.registstep != 3){
							that.$router.push({path: '/RegistType'})
						}
                    }
                })
            },
			scrollLoadData (){
                // console.log(document.documentElement.clientHeight+'-----------'+window.innerHeight); // 可视区域高度  
                // console.log(document.body.scrollTop); // 滚动高度  
                // console.log(document.documentElement.scrollTop); // 滚动高度  
                // console.log(document.body.offsetHeight); // 文档高度  
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                let innerHeight = window.innerHeight;
                let offsetHeight = document.body.offsetHeight;
                // 判断是否滚动到底部  
                if(scrollTop + innerHeight >= offsetHeight) { 
                    // 如果开关打开则加载数据  
                    if(this.loadSwitch && !this.noData){
                        pgno++;
                        this.loadSwitch = false;
                        this.getmessagelist(pgno);
                    }
                }  
            },
			goBack (){
				this.$router.go(-1);
			},
            getmessagelist (pgno){ // 获取近期发布文章数据
                this.loadingShow = true;
                let params = {
                    pageNum: pgno,
                    pageSize: 10,
                }
                let that = this;
                getmessagelist(params).then( result => {
                    if(result.code == 0){
						
                        if(result.data && result.data.list){
						//	for(let i = 0; i < result.data.list.length; i++){
                            	that.messageListData = result.data.list;
                        //	}
                            if(result.data.list.length < 10){
                                that.noData = true;
                            }else{
                                that.noData = false;
                            }
                           
                        }else{
                        	that.loadingShow = false;
                            that.loadingShow = false;
                            that.noData = true;
                            return false;
                        }
                        that.loadSwitch = true;
                    }
                })
            },
		},
		filters:{
			dateFormat:function(val){
				if(val){
					return dateFormat('yyyy-MM-dd hh:mm:ss',new Date(val));
				}

			}
		}
	}
</script>
<style scoped>
	.main .title{
	    position: relative;
	}
	.main-back{
	    float: left;
	    display: inline-block;
	    width: 0.5rem;
	    height: 0.5rem;
	    background: url('./../assets/img/back-btn.png') no-repeat center center;
	    background-size: 0.45rem 0.45rem;
	    position: absolute;
	    top:  0.2rem;
	    left: 0.1rem;
	}
	.sec-list .title {
	    background: #fff;
	    line-height: 0.9rem;
	    font-size: 0.34rem;
	    color: #333333;
	    text-align: center;
	    border-bottom: 1px solid #e1e1e1;
	}

	#newsList {
	    background: #fff;
	}
	#newsList li {
	    padding: 0.3rem;
	    border-bottom: 1px solid #e1e1e1;
	}
	#newsList li .news-title{
	    font-size: 0.30rem;
	    color: #333;
	    line-height: 0.42rem;
	}
	#newsList li .news-time{
	    font-size: 0.24rem;
	    text-align: right;
	    margin-top: 0.24rem;
	    color: #999;
	}
	.no-more {
	    width: 100%;
	    height: 1.1rem;
	    line-height: 1.1rem;
	    text-align: center;
	    font-size: 0.3rem;
	    color: #b3b3b3;
	}

	.footer {
	    display: none;
	    width: 100%;
	    padding: 0.3rem 0;
	    margin: 0 auto;
	    text-align: center;
	}


	/* loading */

	.bg-loading {
	    padding: 0.1rem 0;
	    position: absolute;
	    top: 1.5rem;
	    left: 50%;
	    width: 1.5rem;
	    height: 0.5rem;
	    margin-left: -0.75rem;
	    z-index: 1;
	    display: none;
	}

	.bg-loading .txt {
	    font-size: 0.3rem;
	    padding: 0.2rem 0;
	    text-align: center;
	    color: #52ace5;
	}

	.bg-loading .spinner {
	    margin: 0 auto;
	    width: 1.5rem;
	    height: 0.3rem;
	    text-align: center;
	}

	.bg-loading .spinner>div {
	    width: 0.3rem;
	    height: 0.3rem;
	    background-color: #52ace5;
	    border-radius: 100%;
	    display: inline-block;
	    -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
	    animation: bouncedelay 1.4s infinite ease-in-out;
	    -webkit-animation-fill-mode: both;
	    animation-fill-mode: both;
	}

	.bg-loading .spinner .bounce1 {
	    -webkit-animation-delay: -0.32s;
	    animation-delay: -0.32s;
	}

	.bg-loading .spinner .bounce2 {
	    -webkit-animation-delay: -0.16s;
	    animation-delay: -0.16s;
	}


	/* pull up loading */

	.loading {
	    padding: 0.1rem 0;
	    background-color: #f9f9f9;
	    display: none
	}

	.loading .txt {
	    font-size: 0.22rem;
	    padding: 0.1rem 0;
	    text-align: center;
	    color: #b3b3b3;
	}

	.loading .spinner {
	    margin: 0 auto;
	    width: 1.5rem;
	    text-align: center;
	}

	.loading .spinner>div {
	    width: 0.14rem;
	    height: 0.14rem;
	    background-color: #52ace5;
	    border-radius: 100%;
	    display: inline-block;
	    -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
	    animation: bouncedelay 1.4s infinite ease-in-out;
	    -webkit-animation-fill-mode: both;
	    animation-fill-mode: both;
	}

	.loading .spinner .bounce1 {
	    -webkit-animation-delay: -0.32s;
	    animation-delay: -0.32s;
	}

	.loading .spinner .bounce2 {
	    -webkit-animation-delay: -0.16s;
	    animation-delay: -0.16s;
	}

	@-webkit-keyframes bouncedelay {
	    0%,
	    80%,
	    100% {
	        -webkit-transform: scale(0.0);
	    }
	    40% {
	        -webkit-transform: scale(1.0);
	    }
	}

	@keyframes bouncedelay {
	    0%,
	    80%,
	    100% {
	        transform: scale(0.0);
	        -webkit-transform: scale(0.0);
	    }
	    40% {
	        transform: scale(1.0);
	        -webkit-transform: scale(1.0);
	    }
	}
</style>


// WEBPACK FOOTER //
// src/pages/message.vue